'use client';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default Wrapper;
